import styled from "styled-components";

export const Container = styled.div`
  .select-container {
    background: linear-gradient(
        180deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0.01) 100%
      ),
      ${({ theme }) => theme.styleGuide.colors.gray[200]};
  }
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  margin: 0 -0.6rem;
`;

export const Cell = styled.div`
  padding: 0 0.6rem;

  &:first-child {
    flex-grow: 1;
  }
`;

export const ButtonContainer = styled.div`
  position: relative;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 0.4rem 1.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  border: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.gray[500]};
  border-radius: 0.3rem;
  appearance: none;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  &:active,
  &:focus {
    border-color: ${({ theme }) => theme.live.colors.primary};
  }
`;

export const ButtonIcon = styled.span`
  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 1.2rem;
  }
`;

export const ButtonArrowIcon = styled.span`
  svg {
    width: 2rem;
    height: 2rem;
    margin-right: -0.4rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  }
`;

export const Menu = styled.div`
  width: 100%;
  margin-top: -0.6rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay};
  border-radius: 0.4rem;
  overflow: hidden;
  transform: translateY(-100%);
  position: absolute;
  top: 0;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 0.8rem 1.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  background-color: ${({ theme, isHighlighted }) =>
    isHighlighted
      ? theme.styleGuide.colors.gray[300]
      : theme.styleGuide.colors.white};
  cursor: pointer;

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 1.2rem;
  }
`;

export const Start = styled.a`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  text-decoration: none;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}
`;
